@if (!!item) {
  @switch (item.type) {
    @case ('Grainfather') { <app-fermenter-grainfather-svg [item]="item" /> }
    @case ('Bucket') { <app-fermenter-bucket-svg [item]="item" /> }
    @case ('Carboy') { <app-fermenter-carboy-svg [item]="item" /> }
    @case ('PressurePET') { <app-fermenter-pressure-svg [item]="item" /> }
    @case ('Kegmenter') { <app-fermenter-kegmenter-svg [item]="item" /> }
    @default { <app-fermenter-conical-svg [item]="item" /> }
  }
}
